import createAPI from './hotel-api';

const credentialsConf = {
  withCredentials: true,
  validateStatus: () => true,
};

const api = createAPI(process.env.MUJI_APP_HOST, {
  showNotification: true,
});

export function queryAppTraffic(appKey){
    return api.getJson(`/portal/api/v2/traffic/app/${appKey}`, {}, credentialsConf)
}

export function resetTraffic(type, appKey, apiId, uri, method){
    return api.postJson(`/portal/api/v2/traffic/resetUsed`, {type, appKey, apiId, uri, method}, credentialsConf)
}
